module.exports = __webpack_public_path__ + "img/3ar.4e930ea5.png";